"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnouncementCard = exports.Content = exports.TabsContent = exports.Header = exports.TabHeaders = exports.TabbedCard = exports.Card = void 0;

var _react = _interopRequireDefault(require("react"));

var _PayUIcons = _interopRequireDefault(require("../PayUIcons"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Log = require("../Log");

require("../../assets/css/components/cards.css");

var _reactJss = require("react-jss");

var _PortletStyles = _interopRequireDefault(require("./styles/PortletStyles"));

var _Typography = require("../Blocks/Typography");

var _BootstrapContainers = require("../Blocks/BootstrapContainers");

var _Button = require("../Button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _reactJss.createUseStyles)({
  "@global": _objectSpread({}, _PortletStyles["default"])
});

var Card = function Card(_ref) {
  var noPadding = _ref.noPadding,
      hover = _ref.hover,
      logEventProps = _ref.logEventProps,
      props = _objectWithoutProperties(_ref, ["noPadding", "hover", "logEventProps"]);

  useStyles();
  return _react["default"].createElement(_Log.LogEvent, {
    logEventProps: logEventProps,
    actionProps: {
      onClick: {
        action: 'click'
      }
    }
  }, _react["default"].createElement("div", {
    className: "simple-card ".concat(noPadding ? "no-padding" : "", " ").concat(hover ? "hover" : "")
  }, props.children));
};

exports.Card = Card;

var TabbedCard = function TabbedCard(props) {
  useStyles();
  return _react["default"].createElement("div", {
    className: "portlet-tabs-container"
  }, _react["default"].createElement("div", null, props.children));
};

exports.TabbedCard = TabbedCard;

var TabHeaders = function TabHeaders(_ref2) {
  var type = _ref2.type,
      props = _objectWithoutProperties(_ref2, ["type"]);

  return _react["default"].createElement("ul", {
    className: (0, _clsx["default"])("portlet-tabs nav", {
      "type-two": type == 2,
      "type-three": type == 3
    }),
    role: "tablist"
  }, props.children);
};

exports.TabHeaders = TabHeaders;

var Header = function Header(_ref3) {
  var iconType = _ref3.iconType,
      _ref3$iconSize = _ref3.iconSize,
      iconSize = _ref3$iconSize === void 0 ? "16px" : _ref3$iconSize,
      tabText = _ref3.tabText,
      tabSubText = _ref3.tabSubText,
      _ref3$tabClassName = _ref3.tabClassName,
      tabClassName = _ref3$tabClassName === void 0 ? "" : _ref3$tabClassName,
      tabId = _ref3.tabId,
      _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      logEventProps = _ref3.logEventProps,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick,
      rest = _objectWithoutProperties(_ref3, ["iconType", "iconSize", "tabText", "tabSubText", "tabClassName", "tabId", "active", "logEventProps", "onClick"]);

  return _react["default"].createElement(_Log.LogEvent, {
    logEventProps: logEventProps,
    actionProps: {
      onClick: {
        action: 'click'
      }
    }
  }, _react["default"].createElement("li", {
    onClick: onClick,
    className: (0, _clsx["default"])("nav-item", {
      active: active,
      disabled: rest['disabled']
    })
  }, _react["default"].createElement("a", {
    className: "nav-link",
    id: "".concat(tabId, "-tab"),
    "data-toggle": rest['disabled'] ? "" : "tab",
    role: "tab",
    href: rest['disabled'] ? "#" : rest['tabHref'] || "#".concat(tabId)
  }, _react["default"].createElement("span", {
    className: (0, _clsx["default"])({
      "icon-box": iconType
    }, "left", tabClassName),
    "aria-hidden": "true"
  }, iconType && _react["default"].createElement(_PayUIcons["default"], {
    type: iconType,
    size: iconSize
  })), tabText, tabSubText && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("br", null), _react["default"].createElement("span", {
    "class": "subtext"
  }, tabSubText)))));
};

exports.Header = Header;

var TabsContent = function TabsContent(_ref4) {
  var noPadding = _ref4.noPadding,
      props = _objectWithoutProperties(_ref4, ["noPadding"]);

  return _react["default"].createElement("div", {
    className: "tab-content ".concat(noPadding ? "no-padding top-padding" : "")
  }, props.children);
};

exports.TabsContent = TabsContent;

var Content = function Content(_ref5) {
  var tabId = _ref5.tabId,
      className = _ref5.className,
      active = _ref5.active,
      props = _objectWithoutProperties(_ref5, ["tabId", "className", "active"]);

  return _react["default"].createElement("div", {
    className: (0, _clsx["default"])("tab-pane", className, {
      active: active
    }),
    id: tabId,
    role: "tabpanel"
  }, props.children);
};

exports.Content = Content;

var AnnouncementCard = function AnnouncementCard(_ref6) {
  var themeImage = _ref6.themeImage,
      themeImageClassName = _ref6.themeImageClassName,
      themeImageStyle = _ref6.themeImageStyle,
      cardCaptionClassName = _ref6.cardCaptionClassName,
      announcementCardCaption = _ref6.announcementCardCaption,
      cardIconColorClass = _ref6.cardIconColorClass,
      cardIconColorContainerStyle = _ref6.cardIconColorContainerStyle,
      cardIcon = _ref6.cardIcon,
      cardIconStyle = _ref6.cardIconStyle,
      announcementHeadingClassName = _ref6.announcementHeadingClassName,
      announcementHeadingStyle = _ref6.announcementHeadingStyle,
      announcementHeading = _ref6.announcementHeading,
      firstBtnVariantType = _ref6.firstBtnVariantType,
      firstBtnClassName = _ref6.firstBtnClassName,
      firstBtnStyle = _ref6.firstBtnStyle,
      firstBtnContent = _ref6.firstBtnContent,
      firstBtnOnClick = _ref6.firstBtnOnClick,
      firstBtnType = _ref6.firstBtnType,
      firstBtnIsLoading = _ref6.firstBtnIsLoading,
      firstBtnIsDisabled = _ref6.firstBtnIsDisabled,
      firstBtnLogEventProps = _ref6.firstBtnLogEventProps,
      secondBtnVariantType = _ref6.secondBtnVariantType,
      secondBtnClassName = _ref6.secondBtnClassName,
      secondBtnStyle = _ref6.secondBtnStyle,
      secondBtnContent = _ref6.secondBtnContent,
      secondBtnOnClick = _ref6.secondBtnOnClick,
      secondBtnType = _ref6.secondBtnType,
      secondBtnIsLoading = _ref6.secondBtnIsLoading,
      secondBtnIsDisabled = _ref6.secondBtnIsDisabled,
      secondBtnLogEventProps = _ref6.secondBtnLogEventProps,
      children = _ref6.children,
      hideAnnouncement = _ref6.hideAnnouncement;
  return !hideAnnouncement ? _react["default"].createElement("div", {
    "class": "announcement-card-wrap"
  }, _react["default"].createElement(_BootstrapContainers.Container, null, _react["default"].createElement(_BootstrapContainers.Row, null, _react["default"].createElement(_BootstrapContainers.Col, null, themeImage && _react["default"].createElement("div", null, _react["default"].createElement("img", {
    src: themeImage,
    className: "theme-image ".concat(themeImageClassName),
    style: themeImageStyle
  })), _react["default"].createElement(_Typography.Small, {
    className: "announcement-card-caption ".concat(cardCaptionClassName)
  }, announcementCardCaption))), _react["default"].createElement(_BootstrapContainers.Row, null, _react["default"].createElement(_BootstrapContainers.Col, {
    sm: 1
  }, _react["default"].createElement("span", {
    className: "icon-circle-wrap ".concat(cardIconColorClass),
    style: cardIconColorContainerStyle
  }, _react["default"].createElement("i", null, _react["default"].createElement("img", {
    src: cardIcon,
    style: cardIconStyle
  })))), _react["default"].createElement(_BootstrapContainers.Col, {
    className: "announcement-content"
  }, _react["default"].createElement("span", {
    className: "announcement-heading ".concat(announcementHeadingClassName),
    style: announcementHeadingStyle
  }, announcementHeading), children, _react["default"].createElement("div", null, _react["default"].createElement(_Button.Button, {
    type: firstBtnVariantType,
    className: firstBtnClassName,
    children: firstBtnContent,
    onClick: firstBtnOnClick,
    buttonType: firstBtnType,
    isLoading: firstBtnIsLoading,
    disabled: firstBtnIsDisabled,
    logEventProps: firstBtnLogEventProps,
    style: _objectSpread({
      marginRight: '30px'
    }, firstBtnStyle)
  }), _react["default"].createElement(_Button.Button, {
    type: secondBtnVariantType,
    className: secondBtnClassName,
    children: secondBtnContent,
    onClick: secondBtnOnClick,
    buttonType: secondBtnType,
    isLoading: secondBtnIsLoading,
    disabled: secondBtnIsDisabled,
    logEventProps: secondBtnLogEventProps,
    style: secondBtnStyle
  })))))) : _react["default"].createElement(_react["default"].Fragment, null);
};

exports.AnnouncementCard = AnnouncementCard;